enum InvitationRole {
	seller = 'Seller',
	buyer = 'Buyer',
}

export default InvitationRole;
